import { normalizeLang } from "./lang";

export const DEFAULT_LANG = "en";
export const SUPPORTED_LANGS = [
    "en", // English
 //   "ru", // Russian
  //  "uk", // Ukrainian
  //  "es", // Spanish
  //  "pt", // Portuguese
  //  "de", // German
  //  "fr", // French
  //  "it", // Italian
  //  "nl", // Dutch
  //  "jp", // Japanese
  //  "kr", // Korean
  //  "cn", // Chinese
];


/**
 * Возвращает язык из пути:
 *  - "/ru/face-generator" -> "ru"
 *  - "/face-generator" -> null
 */
export function detectLangFromPath(pathname) {
    const p = String(pathname || "/");
    const parts = p.split("/").filter(Boolean);
    const first = parts[0];
    const lang = normalizeLang(first);
    if (!lang) return null;
    return SUPPORTED_LANGS.includes(lang) ? lang : null;
}

/**
 * Убирает языковой префикс из пути:
 *  - "/ru/face-generator" -> "/face-generator"
 *  - "/face-generator" -> "/face-generator"
 *  - "/ru" -> "/"
 */
export function stripLangFromPath(pathname) {
    const p = String(pathname || "/");
    const parts = p.split("/").filter(Boolean);

    const maybeLang = normalizeLang(parts[0]);
    if (maybeLang && SUPPORTED_LANGS.includes(maybeLang) && maybeLang !== DEFAULT_LANG) {
        const rest = parts.slice(1);
        return "/" + rest.join("/");
    }

    return p.startsWith("/") ? p : `/${p}`;
}

/**
 * Добавляет языковой префикс к пути (EN без префикса):
 *  - withLang("/face-generator","ru") -> "/ru/face-generator"
 *  - withLang("/face-generator","en") -> "/face-generator"
 *  - withLang("/","ru") -> "/ru"
 */
export function withLang(pathname, lang) {
    const cleanLang = normalizeLang(lang) || DEFAULT_LANG;
    const basePath = stripLangFromPath(pathname);
    const normalizedBase = basePath === "" ? "/" : basePath;

    if (cleanLang === DEFAULT_LANG) return normalizedBase;

    // "/" + "ru" + "/" => "/ru"
    if (normalizedBase === "/") return `/${cleanLang}`;
    return `/${cleanLang}${normalizedBase}`;
}

/**
 * Меняет язык в текущем пути (сохраняя "хвост"):
 *  - buildLangPath("/ru/face-generator", "de") -> "/de/face-generator"
 *  - buildLangPath("/face-generator", "ru") -> "/ru/face-generator"
 *  - buildLangPath("/ru", "en") -> "/"
 */
export function buildLangPath(currentPathname, targetLang) {
    return withLang(stripLangFromPath(currentPathname), targetLang);
}

/**
 * Удобная штука для определения "текущего языка страницы":
 * приоритет: URL -> storeLang -> "en"
 */
export function resolveLang({ pathname, storeLang }) {
    return (
        detectLangFromPath(pathname) ||
        (normalizeLang(storeLang) && SUPPORTED_LANGS.includes(normalizeLang(storeLang)) ? normalizeLang(storeLang) : null) ||
        DEFAULT_LANG
    );
}
